import React from 'react';
import { Link } from 'react-router-dom';

export default function PlanningGuides() {
  return (
    <div className="font-inter bg-white text-[#181c24] min-h-screen flex flex-col">
      <main className="flex-1 max-w-6xl mx-auto px-3 py-6">
        <h1 className="text-2xl md:text-3xl font-playfair mb-3 text-center text-[#181c24] tracking-tight">Planning Guides</h1>
        <div className="flex flex-col md:flex-row gap-8">
          <article className="md:w-2/3">
            <h2 className="text-2xl font-semibold mb-4">Welcome to Our Planning Guides</h2>
            <p className="mb-6">Explore our collection of guides to help you plan your perfect destination wedding in Mexico.</p>
            <ul className="list-disc pl-6 space-y-4">
              <li>
                <Link to="/resources/guides/top-venues" className="text-[#bfa76a] hover:underline">The 10 Most Exclusive & Gorgeous Wedding Venues in Mexico</Link>
              </li>
              {/* Add more guides here in the future */}
            </ul>
          </article>
          <aside className="md:w-1/3">
            <section className="p-6 bg-gray-50 rounded-lg mb-6">
              <h2 className="text-xl font-semibold mb-4">About Assemblage</h2>
              <p className="mb-4">Assemblage is your trusted partner in creating unforgettable destination weddings in Mexico. We specialize in curating unique, personalized celebrations that reflect your style and vision. From venue selection to logistics, our team ensures every detail is perfect.</p>
            </section>
            <section className="p-6 bg-gray-50 rounded-lg">
              <h2 className="text-xl font-semibold mb-4">Schedule a Consultation</h2>
              <p className="mb-4">Ready to start planning your dream wedding? Schedule a consultation with us today!</p>
              <a href="/contact" className="inline-block px-4 py-2 bg-[#bfa76a] text-white rounded-full hover:bg-[#a68d5d] transition">Schedule a Consultation</a>
            </section>
          </aside>
        </div>
      </main>
    </div>
  );
} 